import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'GESTION_USER',
  title: 'Comment ajouter ou supprimer des utilisateurs à mon entreprise ?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Pour cela, cliquez sur l’onglet « Paramètres » puis « Utilisateurs ». Vous trouverez la liste des utilisateurs présents sur cette entreprise. Tous les utilisateurs de l’entreprise peuvent voir cette liste et les différents rôles. En revanche seul le Manager de compte peut gérer les ajouts et les suppressions d’utilisateurs.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour ajouter un utilisateur à votre entreprise.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur les paramètres de votre entreprise, puis de l’onglet « Utilisateurs ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_GESTION_USER/FR_GESTION_USER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Vérifiez que vous avez du crédit restant puis cliquez sur « Ajouter un utilisateur »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_GESTION_USER/FR_GESTION_USER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Renseignez l’adresse email, nom, prénom et numéro de téléphone'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_GESTION_USER/FR_GESTION_USER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Puis validez !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_GESTION_USER/FR_GESTION_USER_4.png`
  }]
};
